import React, { Fragment, useContext, useState } from 'react';
import style from "./instapay.module.css";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { UserContext } from '../../Context/UserContext.js';
import { PatientContext } from '../../Context/PatientContext.js';
import { CartContext } from '../../Context/CartContext.js';

export default function Instapay() {
   const { userToken } = useContext(UserContext);
   const { patient } = useContext(PatientContext);
   const { cart, setCart } = useContext(CartContext);
   const [loading, setLoading] = useState(false);
   const [copiedPhone, setCopiedPhone] = useState(false);
   const [copied, setCopied] = useState(false);
   const [send, setSend] = useState(false);
   const textToCopy = "0053171831890701012";

   const navigate = useNavigate();
   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   };

   async function createOrderByInstapay() {
      setLoading(true);
      patient.listIdTest = cart.cartItems.map((ele) => ele.test._id);
      patient.companyId = cart.company._id;
      // patient.profilePrice = cart.profilePrice  ;

      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/order/createCashOrderByInstaPay`, { ...patient }, { headers: header })
         .then((data) => {
            setCart([]);
            toast.success("Created Order Successfully");
            setSend(true);
         })
         .catch((error) => {
            setLoading(false);
            toast.error(error.response.data.message);
         })
   }


   const handleCopy = async () => {
      try {
         await navigator.clipboard.writeText(textToCopy);
         setCopied(true);
         setTimeout(() => setCopied(false), 3000); // يرجع الزر تاني بعد ٢ ثانية
      } catch (err) {
         console.error("Failed to copy: ", err);
      }
   };


   const handleCopyPhone = async () => {
      try {
         await navigator.clipboard.writeText("01066991090");
         setCopiedPhone(true);
         setTimeout(() => setCopiedPhone(false), 3000); // يرجع الزر تاني بعد ٢ ثانية
      } catch (err) {
         console.error("Failed to copy: ", err);
      }
   };


   return (
      <Fragment>
         {console.log(cart)}
         <div className='container'>
            <h1 className='main-header'>إدفع عن طريق انستا باى</h1>
            <div className={`my-5 text-center ${style.instapayInfo}`}>

               <div className='py-3 my-5 fw-bold p-3 border rounded shadow-sm'>
                  <p className='fs-6'> الدفع عن طريق انستا باى على الحساب الاتى</p>
                  <p className='fs-3 '>   البنك الاهلى المصرى</p>
                  <p className='fs-3 '>اسم الشركة : سمارت تريند</p>
                  <div className="text-center">
                     <p className='main-color fs-4'>{textToCopy}  :  رقم الحساب</p>
                     <button onClick={handleCopy} className="btn bg-main btn-sm">
                        {copied ? "✔️ تم النسخ" : "📋 نسخ الحساب "}
                     </button>
                  </div>
               </div>


               <div className='py-3 my-5 fw-bold p-3 border rounded shadow-sm'>
                  <p className='fs-6'> الدفع عن طريق  المحافظ الالكترونية على الرقم الاتى</p>
                  <div className="text-center">
                     <p className='main-color fs-4'> 01066991090  :  رقم التليفون</p>
                     <button onClick={handleCopyPhone} className="btn bg-main btn-sm">
                        {copiedPhone ? "✔️ تم النسخ" : "📋 نسخ التليفون "}
                     </button>
                  </div>
               </div>
               {send ?
                  <div className='text-center'>
                     <p className='text-center main-color'>يرجى أرسال صورة التحويل على الواتس اب لاتمام تأكيد الطلب</p>
                     <Link to="https://wa.me/201066991090" className="btn btn-secondary w-50 "> ارسال صورة التحويل </Link>
                  </div>
                  :
                  <div className='text-center'>
                     {loading ?
                        "Loading....... !"
                        :
                        <>
                           <p
                              className="mb-4 text-secondary text-center "
                              style={{ fontSize: "20px", fontWeight: "600" }}
                           >
                              سيظهر طلبك في صفحة الطلبات بعد استلام صورة التحويل
                           </p>
                           <button onClick={() => { createOrderByInstapay() }} className="btn btn-secondary w-50 ">إتمام طلب الدفع</button>
                        </>
                     }

                  </div>
               }

            </div>
         </div>
      </Fragment>
   )
}
